import React from "react";

import {LeadModel} from "@/typings/models/Lead";

import styles from "./index.less"
import {F} from "@/utils/intl";

const LeadAppointmentServiceType = ({lead, isTable}: {lead: LeadModel, isTable?: boolean}) => {
  const serviceType = lead?.latest_appointment?.branch_service?.service_type
  if (!serviceType?.name) return <div> - </div>
  const content = serviceType.name

  if (isTable) return content

  return <div>
    <div className={styles.tinyDateKey}><F id={"pages.lead.fields.appointmentServiceType"} defaultMessage={"Service Type"}/></div>
    <div>{content}</div>
  </div>

}

export default LeadAppointmentServiceType
